(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["recycling"]) return;
  try {
    
  let button = document.querySelectorAll('.rp-video-player-control');
  let iframe = document.querySelector('iframe');
  let player = new Vimeo.Player(iframe);
  let playing = false;
  player.on('play', function(e) {
playing = true;
<!-- 	button.forEach(e => e.style.visibility = "hidden");     -->
  });

  player.on('pause', function(e) {
    playing = false;
	button.style.display = 'block';
  });

  } catch(e) { console.error(e); }
})();
})();
